import React, { ButtonHTMLAttributes } from 'react';

import Spinner from '../Spinner';

import { Container, SpinnerContainer } from './styles';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'default' | 'outlined';
  loading?: boolean;
  full?: boolean;
  disabled?: boolean;
};

const Button: React.FC<ButtonProps> = ({
  variant = 'default',
  loading = false,
  full = false,
  disabled = false,
  children,
  ...rest
}) => {
  return (
    <Container
      variant={variant}
      loading={loading ? loading.toString() : undefined}
      full={full}
      disabled={disabled || loading}
      {...rest}
    >
      <span>{children}</span>
      {loading && (
        <SpinnerContainer>
          <Spinner />
        </SpinnerContainer>
      )}
    </Container>
  );
};

export default Button;
